import { Client } from "../client.model";

export interface IUser {
  id?: any;
  login?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  activated?: boolean;
  langKey?: string;
  authorities?: any[];
  createdBy?: string;
  createdDate?: Date;
  lastModifiedBy?: string;
  lastModifiedDate?: Date;
  password?: string;
  phone?: string;
  counterSms?: number;
  counterMail?: number;
  counterLoginBO?: number;
  counterExtApi?: number;
  accountType?: string;
  tooltipEnabled?: string;
  chatbotCgu?: boolean;
  chatbotCguDate?: Date;
  client?: Client;
  stepGameClient?: string;
  gender?: string;
  franchisorId?: number;
  companyId?: number;
  matchedScore?: number;
}

export class User implements IUser {
  constructor(
    public id?: any,
    public login?: string,
    public firstName?: string,
    public lastName?: string,
    public email?: string,
    public activated?: boolean,
    public langKey?: string,
    public authorities?: any[],
    public createdBy?: string,
    public createdDate?: Date,
    public lastModifiedBy?: string,
    public lastModifiedDate?: Date,
    public password?: string,
    public phone?: string,
    public counterSms?: number,
    public counterMail?: number,
    public counterLoginBO?: number,
    public counterExtApi?: number,
    public accountType?: string,
    public tooltipEnabled?: string,
    public chatbotCgu?: boolean,
    public chatbotCguDate?: Date,
    public client?: Client,
    public stepGameClient?: string,
    public gender?: string,
    public franchisorId?: number,
    public companyId?: number,
    public matchedScore?: number
  ) {}
}
